import { render, staticRenderFns } from "./image-thumbnail.vue?vue&type=template&id=1d0d4dec&"
import script from "./image-thumbnail.vue?vue&type=script&lang=ts&"
export * from "./image-thumbnail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./image-thumbnail.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports